export const EXECUTION_TICKETS = 'ExecutionTickets';
export const EXECUTION = 'EXECUTION';
